import React, { useEffect, useState } from "react";
import { pdf } from "@react-pdf/renderer";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import InvoiceDocument from "./InvoiceDocument";
import { company, customer, invoice, items, taxRate, payment, notes } from './InvoiceData';
import { useDispatch, useSelector } from "react-redux";
import { InvoiceListApi, InvoiceByIdApi } from "../../apis/api/InvoiceApi";
import Cookies from "js-cookie"
import InvoiceTemplate from "./InvoiceTemplate";
import { useRef } from "react";
import html2pdf from "html2pdf.js";
import Lodderr from "../Lodder/Lodder";


const dummyInvoices = [
  {
    invoice_no: "#1008",
    companyName: "Freight Network",
    invoice_Type: "Upgrade Request",
    invoice_date: "15/01/2025",
    invoice_due_date: "20/01/2025",
    Total_amount: 3500.40,
    status: "Paid",
  },
  {
    invoice_no: "#1007",
    companyName: "Freight Network",
    invoice_Type: "Membership Invoice",
    invoice_date: "12/01/2025",
    invoice_due_date: "16/01/2025",
    Total_amount: 576.28,
    status: "Pending",
  },
  {
    invoice_no: "#1006",
    companyName: "Freight Network",
    invoice_Type: "Late Fee Invoice",
    invoice_date: "11/01/2025",
    invoice_due_date: "13/01/2025",
    Total_amount: 475.22,
    status: "Overdue",
  },
  {
    invoice_no: "#1005",
    companyName: "Freight Network",
    invoice_Type: "Payment Invoice",
    invoice_date: "11/01/2025",
    invoice_due_date: "15/01/2025",
    Total_amount: 767.50,
    status: "Paid",
  },
];

const InvoiceList = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState([]);

  const UserId = Cookies.get("userID");
  const companyId = Cookies.get("company_id");

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const invoiceRef = useRef();

  const dispatch = useDispatch();
  const { resData, invoice, loading } = useSelector(state => state.InvoiceSlice)

  useEffect(() => {
    console.log("Company ID: ", companyId);
    dispatch(InvoiceListApi({UserId, companyId}));
    console.log(resData);
  }, [])

  useEffect(() => {
    console.log("Printing:", resData);
    
    setData(resData.data);
  }, [resData.data])

  useEffect(() => {
    if(invoice){
      console.log("Printing Invoice Here....:", invoice.data);
      setSelectedInvoice(invoice.data);
      setTimeout(() => {
        handlePreview();
      }, 100);
    }

  }, [invoice])

  
  const handleViewClick = async (item) => {
    dispatch(InvoiceByIdApi({ invoiceId: item.id }));
  };


  const handlePreview = () => {
    const element = invoiceRef.current;

    html2pdf()
      .set({
        margin: 10,
        filename: "invoice.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .from(element)
      .outputPdf("blob")
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      });
  };

   const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "bg-warning text-center text-light rounded-pill px-2 fw-bold";
      case 1:
        return "bg-success text-center text-light rounded-pill fw-bold";
      case 2:
        return "bg-danger text-center text-light rounded-pill px-2  fw-bold";
      default:
        return "bg-secondary text-center text-light rounded-pill fw-bold";
    }
  };

  return (
    <>
    {loading && <Lodderr />}
    <CustomTableWrapper
        data={data}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["invoice_type", "invoice_number", "status", "company_name"]}
        columns={[
          { label: "Invoice No", field: "invoice_no", sortable: true },
          { label: "Invoice Type", field: "invoice_Type", sortable: true },
          { label: "Company Name", field: "companyName", sortable: true },
          { label: "Invoice Date", field: "invoice_date", sortable: true },
          { label: "Due Date", field: "invoice_due_date", sortable: true },
          { label: "Amount", field: "Total_amount", sortable: true },
          { label: "Status", field: "status" },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (

          
      
          <tr key={index}>
            <td>{item.invoice_number}</td>
            <td>{item.invoice_type}</td>
            <td>{item.company_name}</td>
            <td>{item.invoice_date}</td>
            <td>{item.invoice_due_date}</td>
          <td>$ {item.total_amount}</td>
            <td ><p className={getStatusColor(item.status)} style={{fontSize: ".87rem"}}>{item.status === 0 ? "Pending" : (item.status === 1) ? "Paid" : "Overdue"}</p></td>
            <td>
              <button
                className="btn btn-sm btn-outline-primary me-2"
                title="View"
                onClick={() => {
                  // downloadPdf(item)
                  handleViewClick(item);
                }}
              >
                <i className="bx bx-show"></i>
              </button>
              {
              item.status !== 1 
              && 
              <button className="btn btn-sm btn-outline-success" title="Pay Now">
                <i className="bx bx-credit-card"></i> Pay
              </button>
              }
              
            </td>
          </tr>

          
        )}
      />
      
      

      <div style={{ display: "none" }}>
        {selectedInvoice && (
          <div ref={invoiceRef}>
            <InvoiceTemplate
              admin={selectedInvoice.admin_data}
              other={selectedInvoice.other_data}
            />
          </div>
        )}
      </div>

    </>
  );
};

export default InvoiceList;
